export default "__VITE_ASSET__DZXw14w2__"